import { BaseURL, cudaApiBase } from '@/utils/cudaOnLine'
import axios from 'axios'

const cudaApi = [{ 0: 'https://u680646-erl9-dd9fb7e3.westd.seetacloud.com:8443' }, { 1: 'https://uu680646-erl9-dd9fb7e3.westd.seetacloud.com:8443' }]
const checkCuda = async () => {
  try {
    const res = await axios.get(BaseURL)
    const temp = []
    res.data.forEach(element => {
      const cudaUse = element['cudaUtilization'].split('%')[0]
      if (cudaUse <= 10) {
        temp.push(element['cudaIndex'])
      }
    })
    return temp
  } catch (error) {
    console.error('检查CUDA状态失败:', error)
    return [] // 出错时返回空数组
  }
}

// 检查CUDA数据库当前状态
const cudaStatusUrl = cudaApiBase + '/cudaStatus'

const cudaCurrentStatus = async () => {
  const res = await axios.get(cudaStatusUrl)
  return res.data
}

// 修改CUDA在数据库中的状态
const changeCudaStatus = cudaApiBase + '/changeCudaStatus'

const changeCudaCurrentStatus = async (cudaIndex, status) => {
  const res = await axios.post(changeCudaStatus, { cuda: cudaIndex, status: status })
  return res.data
}

export default { checkCuda, cudaApi, cudaCurrentStatus, changeCudaCurrentStatus }
